{
  "_comment": "generated by `../../../scripts/set_ls_version.js`",
  "version": "6.7.1"
}
